import PrescriptionCard from '../components/PrescriptionCard';

export default function PrescriptionPage() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2] py-12 px-4">
      <div className="w-full flex flex-col items-center mb-6 md:mb-10">
        <h1 className="text-[#2B3133] font-libreBaskerville text-[32px] md:text-[44px] leading-[1.1em]">
          Prescription
        </h1>
      </div>
      <PrescriptionCard />
    </div>
  );
}
